import { makeStyles } from '@fluentui/react-components';

export const useContainerItemPreviewStyles = makeStyles({
    modalSurface: {
        maxWidth: '90%',
    },
    skeletonWidth75: {
        width: '75%',
    },
    skeletonWidth50: {
        width: '50%',
    },
    skeletonWidth25: {
        width: '25%',
    },
});
